import { html, LitElement } from 'lit';
import '@material/web/list/list.js';

export class IxList extends LitElement {
  render() {
    return html` <md-list><slot></slot></md-list> `;
  }
}
